export default {
  'profile.personalinfo.title.label': 'Informations personnelles',
  'profile.jobinfo.title.label': 'Renseignement profession',
  'profile.healthinfo.title.label': 'Renseignement santé',
  'profile.healthinfo.vaccine.dose.label': 'Dose {doseNum}',
};
